import { useMutation } from '@apollo/client';

import ToggleReasonCodeMutation from '@/graphql/contracts/toggleReasonCode.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ToggleReasonCode, ToggleReasonCodeVariables } from '@/graphql/contracts/_generated_/toggleReasonCode.mutation';
import { notificationService } from '@/services/notification/notification.client';

export function useToggleReasonCode() {

  const [_toggleReasonCode] = useMutation<ToggleReasonCode, ToggleReasonCodeVariables>(
    ToggleReasonCodeMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    }
  );

  const toggleReasonCode = (code: string, enable: boolean) => {
    _toggleReasonCode({
      variables: {
        code,
        enable
      },
    });
  };

  return {
    toggleReasonCode
  } as const;
}
